import { useEffect, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { getCommonProps } from "../../../../keyword-analysis/common/UtilityFunctions";

interface IQueryParams {
    country: string;
    from: string;
    includeSubDomains: boolean;
    isWindow: boolean | undefined;
    keys: string;
    to: string;
    webSource: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    GroupHash: string | undefined;
    sourceType: undefined;
    latest?: string;
}

interface ICommonProps {
    queryParams: IQueryParams;
    isKeywordsGroup: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    GroupHash: string | undefined;
}

export const useCommonProps = (webSourceFromParams = false) => {
    const [commonProps, setCommonProps] = useState<ICommonProps>({
        queryParams: {} as IQueryParams,
        isKeywordsGroup: false,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        GroupHash: undefined,
    });
    const { params } = useCurrentStateAndParams();
    const { country, keyword, isWWW, duration, webSource } = params;

    useEffect(() => {
        const fetchCommonProps = async () => {
            const fetchedCommonProps = await getCommonProps(params, webSourceFromParams);
            setCommonProps(fetchedCommonProps);
        };
        void fetchCommonProps();
    }, [country, keyword, isWWW, duration, webSource, webSourceFromParams]);

    return commonProps;
};
